import React, { Component } from 'react'
import { Button, Col, DatePicker, Input, Row, Select, Tooltip } from 'antd'
import { DOCUMENT_TERMINALS } from '../../utils'
import { ISSUE_OPTIONS, RESOLUTION_MODE_OPTIONS, USER_STATE_OPTIONS } from '../utils'
import * as styles from '../../SearchBar/style.scss'

// The SAME visual language as the Documents search bar, and the same action-column stylesheet
// -- imported, not copied, so the Search/Reset pair keeps the responsive behaviour that was
// measured and approved there and this tab cannot drift from it.
//
// The filter SET is deliberately not the Documents one. This is an operational queue: a row
// here has no sku to search by, or a user id that resolves to nobody, so client/email/amount/
// document-type/clearing would be filters over fields the queue is defined by NOT having.

const ROW = { type: 'flex' as 'flex', gutter: 16, align: 'bottom' as 'bottom', style: { rowGap: '0.8rem' } }
const COL = { xs: 24, sm: 12, md: 8, lg: 6, xl: 4, xxl: 4 }
const LABEL_STYLE = {
    display: 'block',
    marginBottom: '0.35rem',
    fontSize: '0.85rem',
    lineHeight: '1.2rem',
    whiteSpace: 'nowrap' as 'nowrap'
}
const CONTROL_STYLE = { width: '100%', border: 'none' }
const RTL_DROPDOWN = { direction: 'rtl', textAlign: 'right' } as React.CSSProperties

const Field = ({ label, children }) => (
    <Col {...COL}>
        <label style={LABEL_STYLE}>{label}</label>
        {children}
    </Col>
)

export default class UnresolvedSearchBar extends Component<any, any> {
    render() {
        const { filters, setFilter, onSearch, onReset, loading } = this.props

        return (
            <div className="box" style={{ padding: '1rem', marginBottom: '1rem' }}>
                <Row {...ROW}>
                    <Field label="מתאריך">
                        <DatePicker
                            style={CONTROL_STYLE}
                            format="DD/MM/YYYY"
                            value={filters.date_from}
                            onChange={value => setFilter('date_from', value)}
                        />
                    </Field>
                    <Field label="עד תאריך">
                        <DatePicker
                            style={CONTROL_STYLE}
                            format="DD/MM/YYYY"
                            value={filters.date_to}
                            onChange={value => setFilter('date_to', value)}
                        />
                    </Field>

                    <Field label="מסוף">
                        <Select
                            style={CONTROL_STYLE}
                            allowClear
                            placeholder="הכל"
                            dropdownStyle={RTL_DROPDOWN}
                            value={filters.terminal || undefined}
                            onChange={value => setFilter('terminal', value || '')}
                        >
                            {DOCUMENT_TERMINALS.map(terminal => (
                                <Select.Option key={terminal} value={terminal}>
                                    {terminal}
                                </Select.Option>
                            ))}
                        </Select>
                    </Field>

                    <Field label="מס׳ עסקה">
                        <Input
                            style={CONTROL_STYLE}
                            placeholder="לדוגמה: 8548"
                            value={filters.transaction_index}
                            onChange={event => setFilter('transaction_index', event.target.value)}
                            onPressEnter={onSearch}
                        />
                    </Field>

                    <Field label="סוג הבעיה">
                        <Select
                            style={CONTROL_STYLE}
                            dropdownStyle={RTL_DROPDOWN}
                            value={filters.issue}
                            onChange={value => setFilter('issue', value)}
                        >
                            {ISSUE_OPTIONS.map(option => (
                                <Select.Option key={option.value || 'all'} value={option.value}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Field>

                    <Field label="מצב שיוך">
                        <Select
                            style={CONTROL_STYLE}
                            dropdownStyle={RTL_DROPDOWN}
                            value={filters.user_state}
                            onChange={value => setFilter('user_state', value)}
                        >
                            {USER_STATE_OPTIONS.map(option => (
                                <Select.Option key={option.value || 'all'} value={option.value}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Field>

                    {/* "ניתן לפתרון אוטומטי" is reported per row but is deliberately not a filter
                        value: it depends on evidence the server cannot decide inside the paginated
                        query, so offering it would only produce a refusal. */}
                    <Field label="אופן הטיפול">
                        <Select
                            style={CONTROL_STYLE}
                            dropdownStyle={RTL_DROPDOWN}
                            value={filters.resolution_mode}
                            onChange={value => setFilter('resolution_mode', value)}
                        >
                            {RESOLUTION_MODE_OPTIONS.map(option => (
                                <Select.Option key={option.value || 'all'} value={option.value}>
                                    {option.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Field>

                    <Col className={styles.actionsColumn}>
                        <label style={LABEL_STYLE}>&nbsp;</label>
                        <div className={styles.actions}>
                            <Tooltip title="הרשימה נבנית מהמטמון המקומי בלבד, ללא פנייה לטרנזילה">
                                <Button type="primary" icon="search" loading={loading} onClick={onSearch}>
                                    חיפוש
                                </Button>
                            </Tooltip>
                            <Button icon="reload" disabled={loading} onClick={onReset}>
                                איפוס
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}
